import { NgModule } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DatePicker } from 'primeng/datepicker';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { PanelModule } from 'primeng/panel';
import { SharedConfirmationComponent } from '@shared/components/shared-confirmation/shared-confirmation.component';
import { SharedToastComponent } from '@shared/components/shared-toast/shared-toast.component';
import { ToastModule } from 'primeng/toast';
import { SelectModule } from 'primeng/select';
import { CheckboxModule } from 'primeng/checkbox';
import { TextareaModule  } from 'primeng/textarea';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputMaskModule } from 'primeng/inputmask';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

const primeNgModules = [
  ButtonModule,
  DatePicker,
  CheckboxModule,
  ConfirmDialogModule,
  DialogModule,
  SelectModule,
  DynamicDialogModule,
  InputMaskModule,
  InputTextModule,
  InputGroupModule,
  InputGroupAddonModule,
  TextareaModule,
  MultiSelectModule,
  PanelModule,
  ProgressSpinnerModule,
  RadioButtonModule,
  TableModule,
  ToastModule,
  TooltipModule,
  IconFieldModule,
  InputIconModule,
];

@NgModule({
  declarations: [
    SharedConfirmationComponent,
    SharedToastComponent,
  ],
  imports: [...primeNgModules],
  exports: [
    ...primeNgModules,
    SharedConfirmationComponent,
    SharedToastComponent,
  ],
})
export class PrimeNgModule {}
